module.exports = __webpack_public_path__ + "static/media/doctor-img.061c7499.png";